/**
 * react-notifications-component v4 uses .rnc__* classes (see theme.css).
 * Do NOT use animate__* classes unless animate.css is loaded — without it,
 * layout/height calculation breaks (e.g. collapsed ~24px toast).
 * Dynamic import defers loading until first notification (saves ~1.7 KiB from main bundle).
 */
export default function notify(desc, type = "success", title = "") {
  import("react-notifications-component").then(({ Store }) => {
    switch (type) {
      case "snack":
        break;
      case "remove":
        Store.removeAllNotifications();
        break;
      default: {
        Store.removeAllNotifications();
        Store.addNotification({
        title: title || undefined,
        message: desc,
        type,
        insert: "top",
        container: "top-right",
        animationIn: [],
        animationOut: [],
        dismiss: {
          duration: 5000,
          onScreen: true,
          showIcon: true,
        },
      });
        break;
    }
    }
  });
}
